// extracted by mini-css-extract-plugin
export default {"Overlay":"App_Overlay__5Lj3W","App":"App_App__B2Ebb","AppLoadingElement":"App_AppLoadingElement__-Gi7y"};